import { render, staticRenderFns } from "./AlertsChart.vue?vue&type=template&id=9b34c2e8&scoped=true"
import script from "./AlertsChart.vue?vue&type=script&lang=js"
export * from "./AlertsChart.vue?vue&type=script&lang=js"
import style0 from "./AlertsChart.vue?vue&type=style&index=0&id=9b34c2e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b34c2e8",
  null
  
)

export default component.exports